import { Tooltip } from 'bootstrap';

export const tooltipDirective = {
    mounted(el, binding) {
        // Get options from binding or element attributes
        const options = {
            title: binding.value || el.getAttribute('data-bs-title') || '',
            placement: binding.arg || el.getAttribute('data-bs-placement') || 'top',
            trigger: el.getAttribute('data-bs-trigger') || 'hover focus',
            html: el.getAttribute('data-bs-html') === 'true' || false,
            delay: el.getAttribute('data-bs-delay') ? parseInt(el.getAttribute('data-bs-delay')) : 0
        };

        // Create the tooltip instance
        const tooltip = new Tooltip(el, options);

        // Store tooltip instance on element for cleanup
        el._tooltip = tooltip;
    },
    updated(el, binding) {
        // Update tooltip content if it changed
        if (el._tooltip && binding.value !== binding.oldValue) {
            el._tooltip.setContent({ '.tooltip-inner': binding.value || '' });
        }
    },
    beforeUnmount(el) {
        // Clean up tooltip
        if (el._tooltip) {
            el._tooltip.dispose();
            delete el._tooltip;
        }
    }
};
